import React, { useState, useEffect } from 'react'
import { MDBInput } from 'mdbreact';
import axios from 'axios'
import { errores } from '../../hooks/Funciones'
import { SketchPicker } from 'react-color';

const SubirEstados = ({ baseUrl, setFuncion, funcion, registroSelect, peticionTraeDatos }) => {
	//errores

	const [error, setError] = useState({ activo: '' })
	const [registro, setRegistro] = useState(
		funcion === 'editar' ?
			{ ...registroSelect } :
			{ cursos: [] }
	)
	const [displayColorPicker, setDisplayColorPicker] = useState(false);

	//Consulta para subir o crear los datos 
	const peticionPost = async () => {

		let { nombre, color } = registro

		if (nombre !== undefined && color !== undefined) {

			let formData = new FormData()
			formData.append('nombre', nombre)
			formData.append('color', color)
			formData.append('METHOD', 'POST')

			await axios.post(baseUrl, formData)

				.then(response => {
					peticionTraeDatos()
					setFuncion('ver')
				}).catch(error => {
					console.log(error);
				})
		} else errores('CampoVacio', setError)
	}

	const peticionPut = async () => {

		let { nombre, color, id } = registro

		if (nombre !== undefined && color !== undefined && id !== undefined) {
			let f = new FormData()
			f.append('nombre', nombre)
			f.append('color', color)
			f.append('id', id)
			f.append('METHOD', 'PUT')

			await axios.post(baseUrl, f, { params: { id: registro.id } })

				.then(response => {
					peticionTraeDatos()
					setFuncion('ver')
				}).catch(error => {
					console.log(error);
				})

		} else errores('CampoVacio', setError)

	}

	const handleClick = () => {
		setDisplayColorPicker(!displayColorPicker);
	};

	const handleClose = () => {
		setDisplayColorPicker(false);
	};

	const handleChange = (newColor) => {
		setRegistro({ ...registro, color: newColor.hex });
	};
	const styles = {
		color: {
			height: '14px',
			borderRadius: '2px',
			background: registro.color === undefined ? '#000000' : registro.color,
		},
		swatch: {
			width: 'inherit',
			padding: '5px',
			background: '#fff',
			borderRadius: '1px',
			boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
			display: 'inline-block',
			cursor: 'pointer',
		},
		popover: {
			position: 'absolute',
			zIndex: '2',
		},
		cover: {
			position: 'fixed',
			top: '0px',
			right: '0px',
			bottom: '0px',
			left: '0px',
		},
	}


	return (
		<div>
			<div className="row">
				<div className="col-md-12">
					{error.activo ?
						<span className="error"> Error: {error.mensaje}</span> : null
					}
					<div><hr />

						<div className='row '>
							<div className='col-md-4'>
								<div className={`estados`} style={{ marginTop: 28, backgroundColor: registro.color === undefined ? 'white' : registro.color }}>
									{registro.nombre === undefined ? 'Estado' : registro.nombre}
								</div>
							</div>
							<div className='col-md-4'>
								<MDBInput
									label="Nombre del estado" name="nombre" required className={error.campoNombreUser ? "form-control is-invalid" : null} outline
									value={registro.nombre}
									onChange={e => setRegistro({ ...registro, nombre: e.target.value })}
								/>
							</div>
							<div className='col-md-4'>
								<label>Color</label>
								<div style={styles.swatch} onClick={handleClick}>
									<div style={styles.color} />
								</div>
								{displayColorPicker && (
									<div style={styles.popover}>
										<div style={styles.cover} onClick={handleClose} />
										<SketchPicker color={registro?.color} onChange={handleChange} />
									</div>
								)}
							</div>
						</div>

						<br />
						<div className="col text-center">
							<button
								onClick={funcion === 'editar' ? peticionPut : peticionPost}
								className="btn boton_estandar"
							>{`Subir Estado`}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default SubirEstados